import { useState } from "react";
import _ from "lodash";
import DateRangeInput from "../../forms/DateRangeInput";
import * as Convert from "../../utils/convert";
import { fieldFormat } from "../../utils/helper";
import PropTypes from "prop-types";

/**
 * Edit EditDateRangeInput cell component
 * @module
 * @param {func} onChange - Function invoked on change
 * @param {string} dataItem - Data item
 * @param {string} field - Field
 * @param {string} className - TD Class name
 * @param {number} colSpan - Number of columns which cell expands to
 * @param {object} style - Style
 * @param {number} columnIndex - Column index
 * @param {number} level - Level
 * @param {func} render - Render function
 */
export const editDateRangeInputCell = ({ isValueChanged }) => {
  const EditDateRangeInputCell = (props) => {
    let timeout = null;

    const { onChange, dataItem, field, tdProps, format, isInEdit } = props;
    const [value, setValue] = useState(_.get(dataItem, field.split(".")));

    const handleChange = (name, value) => {
      // onChange v inpute vracia name, value !!!
      setValue(value);

      if (timeout) {
        clearTimeout(timeout);
        timeout = null;
      }

      timeout = setTimeout(() => {
        onChange({
          dataItem: dataItem,
          field: field,
          syntheticEvent: null,
          value: value,
        });

        timeout = null;
      }, 1000);
    };

    // format je fixny dd.mm.yyyy
    const newFormat = format ? fieldFormat(format) : "dd.MM.y";
    const dataValue = value;

    return <td
      {...tdProps}
      className={`${tdProps.className} ${isValueChanged && isValueChanged(dataItem, field) ? "k-state-changed" : ""}`}
      tabIndex={0}
    >
      {isInEdit ? (
        <DateRangeInput onChange={handleChange} value={dataValue} />
      ) : (
        `${Convert.dateToStr(dataValue?.start, newFormat)}-${Convert.dateToStr(dataValue?.end, newFormat)}`
      )}
    </td>

  };

  EditDateRangeInputCell.propTypes = {
    onChange: PropTypes.func,
    dataItem: PropTypes.object,
    field: PropTypes.string,
    className: PropTypes.string,
    colSpan: PropTypes.number,
    style: PropTypes.object,
    columnIndex: PropTypes.number,
    level: PropTypes.number,
    render: PropTypes.func,
  };

  return EditDateRangeInputCell;
};
